import http from "./httpServices";
import config from "../config.json";

export function contact(data) {
  return http.post(config.apiUrl + "contact", data);
}

export function checkPlanPricing(data) {
  return http.post(config.apiUrl + "checkPlanPricing", data);
}
